<template>
<div class="box__container">
<div class="box__header">
	<div class="box__header__title">
		<h2>{{ dialogName | capitalize }}</h2>
	</div>
</div>
<div class="box__body">
	<div class="box__body__subtitle" v-if="dialogDescription">
		<p>{{ dialogDescription | capitalize }}</p>
	</div>
	<form @submit.prevent="registerDialog($event)" :data-dialog="dialogId">
		<div class="form__group" v-for="(question, index) in questions" :key="question.id">
				<div class="label-wrap">
					<label>
						{{ question.content }} <template v-if="windowLocation">{{ question.name }}</template>
					</label>
					<div v-if="question.answer" class="dialog-on-off-switch">
						<div class="on-off-switch">
							<input
								type="checkbox"
								class="on-off-switch on-off-switch-checkbox"
								:id="question.id" value="1"
								v-model="question.answer.active"
								@change="toggleDialog(questions, index)"
							>
							<label class="on-off-switch-label" :for="question.id">
								<span class="on-off-switch-inner"></span>
								<span class="on-off-switch-switch"></span>
							</label>
						</div>
					</div>
				</div>
				<textarea :data-target-id="question.id" :name="(question.answer !== null) ? `question[${question.id}][answer][${question.answer.id}]`:`question[${question.id}][answer]`" :value="(question.answer !== null) ? question.answer.content: ''" @input="buttomAvailable($event, 1000)" minlength="1" maxlength="1000" placeholder="Resposta" required></textarea>
				<!-- <span :id="`tam${question.id}`" class="text-lenght label pull-right bg-red counter"></span> -->
			</div>

		<div class="form__group submit__content">
			<div class="form__validation" v-show="successMsg">
				<p><i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}</p>
			</div>
			<div class="form__group submit__content">
				<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
					{{ 'save' | translate | capitalize }}
				</button>
			</div>
			<div class="has-success-message" v-show="successMsg">
				<template>
					<i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}
				</template>
			</div>
		</div>
	</form>
</div>
</div>
</template>

<script>

export default {
	name: 'my-dialog',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			successMsg: false,
			submitLoading: false,
			questions: this.dialogQuestions,
		};
	},
	props: {
		dialogName: {
			type: String,
			required: true,
		},
		dialogId: {
			type: Number,
			required: true,
		},
		dialogDescription: {
			type: String,
			required: true,
		},
		dialogQuestions: {
			type: Array,
			required: true,
		},
	},
	computed: {
		error() {
			return this.$store.state.error;
		},
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
		windowLocation() {
			if (window.location.host === 'app.mandatoaberto.com.br') {
				return false;
			}
			return true;
		},
	},
	watch: {
		dialogQuestions() {
			this.questions = this.dialogQuestions;
		},
	},
	methods: {
		toggleSubmitLoading() {
			this.submitLoading = !this.submitLoading;
		},
		errorForm(obj, field) {
			let erro = false;
			if (obj) {
				if (obj[field]) {
					erro = true;
				}
			}
			return erro;
		},
		buttomAvailable(event, limit) {
			const elem = document.getElementById(`id${event.target.dataset.targetId}`);
			elem.textContent = event.target.value;
			const lengthText = document.getElementById(`tam${event.target.dataset.targetId}`);
			lengthText.textContent = (event.target.value.length - limit) * -1;
		},
		toggleDialog(dialogQuestions, index) {
			const payload = {};
			const myStatus = dialogQuestions[index].answer.active === true ? 1 : 0;
			payload.active = myStatus;
			payload.id = dialogQuestions[index].answer.id;
			this.$store.dispatch('editDialog', this.getFormData(payload))
				.then(() => {
					this.validate();
				});
		},
		getFormData(object) {
			const formData = new FormData();
			Object.keys(object).forEach(key => formData.append(key, object[key]));
			return formData;
		},
		registerDialog(event) {
			const items = Array.from(event.target);
			const dialogForm = items.map(element => `${element.name}=${element.value}`);
			const payload = {};
			payload.dialogForm = dialogForm.join('&');


			this.toggleSubmitLoading();
			this.$store.dispatch('registerDialog', payload)
				.then(() => {
					this.$store.dispatch('getDialog', this.session).then(() => {
						this.toggleSubmitLoading();
						this.validate();
					});
				})
				.catch(() => {
					this.toggleSubmitLoading();
				});
		},
		validate() {
			if (this.success) {
				this.successMsg = this.success;
				setTimeout(() => {
					this.successMsg = false;
				}, 5000);
			}
		},
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/profile/myDialog.vue